module.exports = __webpack_public_path__ + "static/media/logo_corridaperfeita_amarelo.0641ac84.png";